import React from 'react';
import {CBCButton} from 'shared/helpers';
import {usePDFLinks} from 'shared/components/Header/helper/usePDFLinks';
import {PDFDropdown} from 'shared/components/Header/helper/PDFDropdown';
import styled from 'styled-components';

export const PDFReportButtons = () => {
    const {pdfDialog, pdfDropDown} = usePDFLinks();

    if (pdfDropDown) {
        if (pdfDropDown.filter((dropdown) => dropdown.show).length == 1) {
            return (
                <>
                    {pdfDialog}
                    <CBCButton
                        asLink
                        to={pdfDropDown[0].link}
                        target="_blank"
                        rel="noreferrer"
                        type="submit"
                        iconName="Button-Create-PDF.svg"
                        className="job-button button-primary">
                        {pdfDropDown[0].name}
                    </CBCButton>
                </>
            );
        } else {
            return (
                <StyledPDFDropdown
                    dialog={pdfDialog}
                    dropDowns={pdfDropDown}
                    smallButton={false}
                />
            );
        }
    }
};

const StyledPDFDropdown = styled(PDFDropdown)`
    padding: 6px 20px 6px 6px !important;
    background: ${({theme}) => theme.colors.primary.main};
    width: 100%;

    > img {
        width: 30px !important;
    }
`;
